import { Div } from '../../../base/components/native/div'

export const UserItem = (user: any) => {

    
    const base = Div()
    const name = Div(user.name)
    const email = Div(user.email)
    const phone = Div(user.phone || '')
    const points = Div('Points: ' + (user.points || '0'))
    base.append(name, email, phone/* , points */)

    base.cssClass({
        marginBottom: '30px',
        textAlign: 'left',
        cursor: 'pointer',
    })

    return base
}

